import { useScrollPosition } from "@/hooks";
import clsx from "clsx";
import AdminBar from "./components/AdminBar";
import NavBar from "./components/NavBar";
import TopBar from "./components/TopBar";
import { useAuth0 } from "@auth0/auth0-react";

const Header = () => {
    const [, verticalScrollPosition] = useScrollPosition();
    const { isAuthenticated } = useAuth0();

    return (
        <>
            {isAuthenticated && <AdminBar />}
            
            <header
                className={clsx([
                    "bg-white z-20 select-none sticky top-0 pb-2",
                    "transition-all duration-300",
                    verticalScrollPosition > 5 && "shadow-lg bg-white",
                ])}
            >
                <TopBar />
                <NavBar />
            </header>
        </>
    );
};

export default Header;
